import dynamic from 'next/dynamic'
import type { StyledDialogProps } from './StyledDialog'
export type { StyledDialogProps }

export const StyledDialog = dynamic(
  () => import('./StyledDialog').then((mod) => mod.StyledDialog),
  {
    ssr: false,
  },
)
